import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SimNumber, SimNumberSearch } from 'src/app/change/shared/state/sim-change.action';
import { LoggerService } from '../common';
import { CORE_CONFIGURATION } from '../configuration';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { SessionState, SessionStateModel } from '../session';
import { Store } from '@ngxs/store';
import { buildAwsApi } from '../util.class';



@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class ChangeApiService {
  keyMapAWS: any;

  constructor(
        private http: BaseApiService,
        @Inject(CORE_CONFIGURATION) private config,
        private logger: LoggerService,
        private store: Store
  ) {
    const { keyMapAWS }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }

  /**
     * Sim-Change api get list sim number associated to chooser
     * @param SimNumber
     */
  listSimNumber({ params }: SimNumber): Observable<any>{
    const httpParams = this.setParams(params);

    return this.http.get({
      apiBasePath: '',
      path: '/infoconsistency/v1/infoconsistency',
      params: httpParams
    });
  }

  /**
   * Sim-Change api get list sim number related to a search
   * @param SimNumberSearch
   */
  searchSimNumber(params: any): Observable<any>{
    const httpParams = this.setParams(params);
    return this.http.get({
      apiBasePath: '',
      path: '/BusinessSelector/v1/businessSelector',
      params: httpParams
    });
  }

  /**
   * Link-Account-Change api get list link account associated to chooser
   * @param limit limit of landline to be retrieved
   * @param offset offset used as starting point to retrieve landline
   * @param toSearch li or linkAccount to search
   * @param wirelessFlag Boolean value used to filter in or out the link wireless from the research
   */
  listLinkAccount(
    toSearch: string = '',
    offset: number = 0,
    limit: number = 0,
    wirelessFlag: boolean = false
  ): Observable<any> {
    const params = { toSearch, offset, limit, wirelessFlag };
    let httpParams = new HttpParams();

    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'asset_landline_fe', params);

    if(!apiAWS) {
      httpParams = this.setParams(params);
    }

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? '/v2/profile/v1/landline',
      params: httpParams,
      awsApi: apiAWS !== null,
    });
  }

  private setParams(params: any){
    let httpParams = new HttpParams();

    Object.keys(params).forEach(
      (key) => {
        httpParams = httpParams.append(key, params[key]);
      }
    );
    return httpParams;
  }
}
